import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
// import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
// import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import SkipNextIcon from '@material-ui/icons/SkipNext';
import developer from '../assets/images/developer-img.jpg'
const useStyles = makeStyles({
    parent:{
        height: '600px',
        
    },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '2.5%',
    marginTop: '4%',
    marginBottom: '2%',
    padding: '4%',
    justifyContent: 'space-around',
    
  },
  details: {
    width: '400px'
  },
//   content: {
//     flex: '1 0 auto',
//   },
  cover: {
    width: '100%',
    height: '400px',
    padding: '1%',
   
  },
  
});

const About = () => {

    const classes = useStyles();
    const theme = useTheme();
    return (
        <div className={classes.prent}>
        <Card className={classes.root}>
      <div className={classes.details}>
        <CardContent className={classes.content}>
        
          <Typography component="h5" variant="h5" style={{marginBottom: '2%'}}>
            About me
          </Typography>
     
          <Typography variant="subtitle1" color="textSecondary">

            A computer management graduate, having experience of 2+ years. I have completed projects in ReactJS, NodeJS, and ExpressJS frameworks.<br></br>
            <br></br>
            A full stack developer who knows which technology best suites for your front-end and back-end development. 
            Having experience with content management state like Redux, Redux-Sagas, and other technology like Axios, jQuery, HTML, CSS, SCSS, SASS, bootstrap, reactStrap and material-ui.<br></br>
            I have worked with databases MongoDB and MySQL.
            <br></br>
            <br></br>
            I believe programming language is just a medium, in reality your skills matters the most.
          </Typography>
        </CardContent>
        
      </div>
     <div style={{width: '300px'}}>
      <CardMedia
        className={classes.cover}
        image={developer}
        title="developer "
      />
      </div>
     
    </Card>
    </div>
    )
}

export default About
